import { render } from "./CategoriasZonas.vue?vue&type=template&id=06cab775"
import script from "./CategoriasZonas.vue?vue&type=script&lang=js"
export * from "./CategoriasZonas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__